import React, { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import Box from "@material-ui/core/Box";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { showSuccessAlert, showErrorAlert } from "../../store/actions/alerts";
import AddEditCorrectionForm from "./AddEditCorrectionForm";
import ConfirmDialog from "../dialog/ConfirmDialog";
import NullChip from "../chips/NullChip";

import makeApiRequest from "../../utils/axios/new-axios";
import { permissions, types, checkAcl } from "../../utils/acl";

import { ADM_AREAS_CORRECTION_DELETE_URL } from "../../config";

const useStyles = makeStyles(theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  paper: {
    width: "100%",
    overflowX: "auto",
    marginBottom: theme.spacing(2),
    backgroundColor: "#212121"
  }
}));

export default function AdmCorrections({ corrections, parentId }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const EDIT_ACCESS = checkAcl({ p: permissions.ADMINISTRATIVE_AREA_MANAGEMENT, t: types.VIEW_AND_EDIT });
  const DELETE_ACCESS = checkAcl({ p: permissions.ADMINISTRATIVE_AREA_MANAGEMENT, t: types.VIEW_EDIT_AND_DELETE });

  const [correctionArray, setCorrectionArray] = useState([]); //should not set to null
  const [action, setAction] = useState(null);
  const [openAddEditModal, setOpenAddEditModal] = useState(false);
  const [values, setValues] = useState(null);
  const [correctionId, setCorrectionId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  function handleOpenConfirmDialog() {
    setOpenConfirmDialog(true);
  }

  function handleCloseConfirmDialog() {
    setOpenConfirmDialog(false);
    setCorrectionId(null);
  }

  function handleOpenAddEditModal() {
    setOpenAddEditModal(true);
  }

  function handleCloseAddEditModal() {
    setOpenAddEditModal(false);
    setValues(null);
  }

  function addButtonClick() {
    //clear values for adding new
    setValues({
      country: "",
      countryAlt: "",
      adm1: "",
      adm1Alt: "",
      adm2: "",
      adm2Alt: "",
      adm3: "",
      adm3Alt: ""
    });
    setAction("add");
    handleOpenAddEditModal();
  }

  function editButtonClick(id) {
    setCorrectionId(id);
    let selected = null;
    for (let i = 0; i < correctionArray.length; i++) {
      if (correctionArray[i].id === id) {
        selected = correctionArray[i];
        break;
      }
    }

    if (selected) {
      setValues({
        country:
          !!selected.country && !!selected.country.name
            ? selected.country.name
            : "",
        countryAlt:
          !!selected.country && !!selected.country.nameAlt
            ? selected.country.nameAlt
            : "",
        adm1: !!selected.adm1 && !!selected.adm1.name ? selected.adm1.name : "",
        adm1Alt:
          !!selected.adm1 && !!selected.adm1.nameAlt
            ? selected.adm1.nameAlt
            : "",
        adm2: !!selected.adm2 && !!selected.adm2.name ? selected.adm2.name : "",
        adm2Alt:
          !!selected.adm2 && !!selected.adm2.nameAlt
            ? selected.adm2.nameAlt
            : "",
        adm3: !!selected.adm3 && !!selected.adm3.name ? selected.adm3.name : "",
        adm3Alt:
          !!selected.adm3 && !!selected.adm3.nameAlt
            ? selected.adm3.nameAlt
            : ""
      });
      setAction("edit");
      handleOpenAddEditModal();
    }
  }

  function deleteButtonClick(id) {
    setCorrectionId(id);
    handleOpenConfirmDialog();
  }

  async function deleteCorrection(id) {
    setIsSubmitting(true);
    await makeApiRequest({
      url: `${ADM_AREAS_CORRECTION_DELETE_URL.url}/${id}`,
      method: ADM_AREAS_CORRECTION_DELETE_URL.method
    })
      .then(response => {
        setCorrectionArray([
          ...correctionArray.filter(correction => {
            return correction.id !== id;
          })
        ]);
        dispatch(showSuccessAlert("Deleted Successfully"));
      })
      .catch(error => {
        dispatch(
          showErrorAlert(
            "Correction Delete Error : " +
            (!!error.response
              ? `${error.response.status}! - ${error.response.data.errorMessage}`
              : error.message)
          )
        );
      });
    handleCloseConfirmDialog();
    setIsSubmitting(false);
    setCorrectionId(null);
  }

  function updateCorrectionTable(action, values, id) {
    // console.log("values : ", values);
    // console.log("id : ", id);
    if (action === "add") {
      setCorrectionArray([...correctionArray, values]);
    } else if (action === "edit") {
      setCorrectionArray([
        ...correctionArray.filter(correction => {
          return correction.id === id
            ? ((correction.country = values.country),
              (correction.adm1 = values.adm1),
              (correction.adm2 = values.adm2),
              (correction.adm3 = values.adm3))
            : correction;
        })
      ]);
    }

    setCorrectionId(null);
  }

  useEffect(() => {
    !!corrections && setCorrectionArray([...corrections]);
  }, [corrections]);

  return (
    <Fragment>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="adm-correction-content"
          id="adm-correction-header"
        >
          <Typography className={classes.heading}>
            Google API Corrections
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box component="span" display="block" width="100%">
            {!!correctionArray && correctionArray.length > 0 ? (
              <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Country</TableCell>
                      <TableCell>Country Alt</TableCell>
                      <TableCell>Adm-1</TableCell>
                      <TableCell>Adm-1 Alt</TableCell>
                      <TableCell>Adm-2</TableCell>
                      <TableCell>Adm-2 Alt</TableCell>
                      <TableCell>Adm-3</TableCell>
                      <TableCell>Adm-3 Alt</TableCell>
                      {EDIT_ACCESS &&
                        <TableCell>Actions</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {correctionArray.map(item => {
                      return (
                        <TableRow key={item.id}>
                          <TableCell>
                            {!!item.country.name ? (
                              item.country.name
                            ) : (
                              <NullChip />
                            )}
                          </TableCell>
                          <TableCell>
                            {!!item.country.nameAlt ? (
                              item.country.nameAlt
                            ) : (
                              <NullChip />
                            )}
                          </TableCell>
                          <TableCell>
                            {!!item.adm1.name ? item.adm1.name : <NullChip />}
                          </TableCell>
                          <TableCell>
                            {!!item.adm1.nameAlt ? (
                              item.adm1.nameAlt
                            ) : (
                              <NullChip />
                            )}
                          </TableCell>
                          <TableCell>
                            {!!item.adm2.name ? item.adm2.name : <NullChip />}
                          </TableCell>
                          <TableCell>
                            {!!item.adm2.nameAlt ? (
                              item.adm2.nameAlt
                            ) : (
                              <NullChip />
                            )}
                          </TableCell>
                          <TableCell>
                            {!!item.adm3.name ? item.adm3.name : <NullChip />}
                          </TableCell>
                          <TableCell>
                            {!!item.adm3.nameAlt ? (
                              item.adm3.nameAlt
                            ) : (
                              <NullChip />
                            )}
                          </TableCell>
                          {EDIT_ACCESS &&
                            <TableCell style={{ paddingLeft: "0px" }}>
                              <Box display="flex" flexWrap="no-wrap">

                                <IconButton
                                  className={classes.button}
                                  aria-label="edit-correction"
                                  onClick={() => editButtonClick(item.id)}
                                >
                                  <EditIcon />
                                </IconButton>
                                {DELETE_ACCESS &&
                                  <IconButton
                                    className={classes.button}
                                    aria-label="delete-correction"
                                    onClick={() => deleteButtonClick(item.id)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>}
                              </Box>
                            </TableCell>}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Paper>
            ) : (
              <Box justifyContent="center" display="flex">
                No Correction Records !!
              </Box>
            )}
            {EDIT_ACCESS &&
              <Box
                justifyContent="center"
                display="flex"
                style={{ marginTop: "15px" }}
              >
                <Fab
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={addButtonClick}
                >
                  <AddIcon />
                </Fab>
              </Box>}
          </Box>
        </AccordionDetails>
      </Accordion>
      {EDIT_ACCESS &&
        <AddEditCorrectionForm
          openModal={openAddEditModal}
          handleCloseModal={handleCloseAddEditModal}
          initialValues={values}
          action={action}
          parentId={parentId}
          correctionId={correctionId}
          updateCorrectionTable={updateCorrectionTable}
        />}
      <ConfirmDialog
        openDialog={openConfirmDialog}
        handleCloseDialog={handleCloseConfirmDialog}
        title={"Delete Adm Google Correction"}
        message={"Are you sure you want to delete?"}
        buttonLabel={"Delete"}
        isSubmitting={isSubmitting}
        selectedIndex={correctionId}
        handleSubmit={deleteCorrection}
      />
    </Fragment>
  );
}
